import React from "react";
import { MovementPatternType } from "@growth-machine-llc/stridist-api-client";
import { ExerciseCategoriesFilter } from "./ExerciseCategoriesFilters";
import { MovementPatternTypeLabels } from "../constants";
import { mapFilters } from "./filterUtils";

export function MovementPatternFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: MovementPatternType[]) => void;
  contextFilters?: MovementPatternType[];
  className?: string;
}) {
  const [filters, setFilters] = React.useState(() =>
    mapFilters(MovementPatternType, contextFilters),
  );

  React.useEffect(() => {
    setFilters(mapFilters(MovementPatternType, contextFilters));
  }, [contextFilters]);

  const extractSelected = React.useCallback(
    (filters: Record<MovementPatternType, boolean>): MovementPatternType[] =>
      Object.entries(filters)
        .filter(([_, checked]) => checked)
        .map(([key]) => key as MovementPatternType),
    [],
  );

  const handleChange = React.useCallback(
    (newFilters: Record<MovementPatternType, boolean>) => {
      const selected = extractSelected(newFilters);
      onChange?.(selected);
    },
    [extractSelected, onChange],
  );

  return (
    <ExerciseCategoriesFilter
      filters={filters}
      onChange={handleChange}
      filterTypesLabels={MovementPatternTypeLabels}
      labelType="Movements"
      className={className}
    />
  );
}
